import { api } from '../api';

export async function getTutorialsReport(status, required) {
    try {
        const params = new URLSearchParams();
        if (status) params.append('status', status);
        if (required !== undefined && required !== null && required !== '') {
            params.append('required', required);
        }

        const { data } = await api.get(`/tutorials/report/user?${params.toString()}`);
        return data;
    } catch (error) {
        return false;
    }
}

export async function getTutorials(required) {
    try {
        const params = new URLSearchParams();
        if (required !== undefined && required !== null && required !== '') {
            params.append('required', required);
        }

        const queryString = params.toString();
        const { data } = await api.get(`/tutorials?${queryString}`);
        return data;
    } catch (error) {
        return false;
    }
}

export async function settutorialUser(tutorial_id, status, tempo) {
    try {
        const params = new URLSearchParams();
        if (tutorial_id) params.append('tutorial_id', tutorial_id);
        if (status) params.append('status', status);
        if (tempo !== undefined && tempo !== null && !isNaN(tempo)) {
            params.append('tempo', Math.floor(Number(tempo)));
        }

        const { data } = await api.post(`/tutorials/user?${params.toString()}`);
        return data;
    } catch (error) {
        return false;
    }
}